import { render, staticRenderFns } from "./getLabelView.vue?vue&type=template&id=81ac1f34&scoped=true&"
import script from "./getLabelView.vue?vue&type=script&lang=js&"
export * from "./getLabelView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ac1f34",
  null
  
)

export default component.exports